import React from "react";
import PropTypes from "prop-types";
import { CollapsibleSection } from "@opendate-app/setlist";

const BuilderSection = ({ title, desc, children }) => (
  <div className="sf-section">
    <CollapsibleSection defaultOpen title={title}>
      {desc && <p className="sf-section-desc">{desc}</p>}
      <div className="sf-section-fields">{children}</div>
    </CollapsibleSection>
  </div>
);

BuilderSection.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  children: PropTypes.node,
};

export default BuilderSection;
